import {Controller} from "stimulus";

export default class extends Controller {
    connect() {
        if (!this.element.hasAttribute("data-tabs-sync-url")) return;

        const params = new URLSearchParams(window.location.search);
        const tab = params.get("tab");
        if (tab && /^[a-zA-Z0-9_-]+$/.test(tab)) {
            const tabLink = this.scoped(`.tab-link[data-tab="tab-${tab}"]`)[0];
            if (tabLink && tabLink.dataset.disabled !== "true") {
                this.activateTabById(tabLink.dataset.tab);
            }
        }
    }

    changeTab(e) {
        let tabId;
        if (e.currentTarget.tagName === "SELECT") {
            tabId = e.currentTarget.selectedOptions[0].dataset.tab;
        } else {
            e.preventDefault();
            if (e.currentTarget.dataset.disabled === "true") return;
            tabId = e.currentTarget.dataset.tab;
        }

        this.activateTabById(tabId);
    }

    // Elements this controller owns: matches nested inside another tabs controller
    // belong to that controller, not this one, so hat tabs never hide the assignee
    // panels living inside them.
    scoped(selector) {
        return Array.from(this.element.querySelectorAll(selector))
            .filter(el => el.closest('[data-controller~="tabs"]') === this.element);
    }

    activateTabById(tabId) {
        const destinationTab = this.scoped(`#${tabId}`)[0];

        // Hide all tab panels
        this.scoped('.tab').forEach(tab => {
            tab.classList.add('hidden');
        });

        // Remove active state from all tab links
        this.scoped('.tab-link').forEach(link => {
            if (link.dataset.disabled !== "true") {
                link.classList.remove('border-indigo-500', 'text-indigo-600');
                link.classList.add('border-transparent', 'text-gray-500', 'hover:border-gray-300', 'hover:text-gray-700');
            }
            link.setAttribute('aria-selected', 'false');
        });

        // Show the selected tab panel
        if (destinationTab) {
            destinationTab.classList.remove('hidden');
        }

        // Add active state to the matching tab link
        const activeLink = this.scoped(`.tab-link[data-tab="${tabId}"]`)[0];
        if (activeLink) {
            activeLink.classList.add('border-indigo-500', 'text-indigo-600');
            activeLink.classList.remove('border-transparent', 'text-gray-500', 'hover:border-gray-300', 'hover:text-gray-700');
            activeLink.setAttribute('aria-selected', 'true');
        }

        // Update URL query parameter when sync-url is enabled
        if (this.element.hasAttribute("data-tabs-sync-url")) {
            const tabName = tabId.startsWith("tab-") ? tabId.slice(4) : tabId;
            const url = new URL(window.location.href);
            url.searchParams.set("tab", tabName);
            window.history.replaceState(null, "", url.toString());
        }
    }
}
